import React, { useState } from "react";
import { flushSync } from "react-dom";
import { CategoryType } from "../TagFilter";
import CheckboxListOptions from "./CheckboxListOptions/CheckboxListOptions";
import RadioButtonListOptions from "./RadioButtonListOptions/RadioButtonListOptions";
import DateOption from "./DateOption/DateOption";

// Styles
import "./FilterModal.scss";

const FilterModal = ({
  filterCategories,
  setFilterCategories,
  handleFilterTags,
  setIsModalOpen,
  isSearchCategory,
  handleClear,
}) => {
  // const [categories, setCategories] = useState([...filterCategories]);
  const [searchCategoryString, setSearchCategoryString] = useState("");
  const [activeCategory, setActiveCategory] = useState(0);

  const handleApply = () => {
    // To update state in sync manner
    flushSync(() => {
      setFilterCategories((categories) => {
        const tempCategories = [...categories];
        tempCategories.forEach((category) => {
          if (category.type === CategoryType.Checkbox) {
            category.options.forEach((option) => {
              if (option.isSelectedTemp !== option.isSelected) {
                option.isSelected = option.isSelectedTemp;
              }
            });
          } else if (category.type === CategoryType.RadioButton) {
            category.selectedValue = category.tempSelectedValue;
          } else if (category.type === CategoryType.Date) {
            category.selectedStartValue = category.tempSelectedStartValue;
            category.selectedEndValue = category.tempSelectedEndValue;
            category.selectedMatrix = category.tempSelectedMatrix;
          }
          category.filterCount = category.tempFilterCount;
        });

        return tempCategories;
      });
    });
    handleFilterTags(filterCategories);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCategoryClick = (index) => {
    setActiveCategory(index);
  };

  const category = filterCategories[activeCategory];
  return (
    <div className="filter-modal-container">
      <div className="filter-header">
        <p className="title">Filters</p>
        <div className="left">
          {/* <div href="#/" onClick={clearFilter} className="clear-all">
            Clear all
          </div> */}
        </div>
      </div>

      <div className="filter-body">
        <div className="filter-body-left">
          {isSearchCategory ? (
            <div className="search-container">
              <input
                type="text"
                maxLength="300"
                placeholder="Search filters"
                onChange={(e) => setSearchCategoryString(e.target.value)}
                value={searchCategoryString}
              />
            </div>
          ) : null}

          <div className="category-container">
            {filterCategories.map((category, index) =>
              category.name.toLowerCase().includes(searchCategoryString.trim().toLowerCase()) ? (
                <div
                  key={category.id}
                  className={`category ${activeCategory === index ? "selected" : ""} `}
                  onClick={() => handleCategoryClick(index)}
                >
                  {category.name}
                  {category.tempFilterCount > 0 ? <div className="filter-count">{category.tempFilterCount}</div> : null}
                </div>
              ) : null
            )}
          </div>
        </div>
        <div className="filter-body-right">
          {category.type === CategoryType.Checkbox ? (
            <CheckboxListOptions {...{ category, filterCategories, setFilterCategories, activeCategory }} />
          ) : category.type === CategoryType.RadioButton ? (
            <RadioButtonListOptions
              {...{ category, filterCategories, setFilterCategories, activeCategory, showSearchOption: false }}
            />
          ) : category.type === CategoryType.Date ? (
            <DateOption {...{ category, filterCategories, setFilterCategories, activeCategory }} />
          ) : null}
        </div>
      </div>

      <div className="filter-footer">
        <div className="clear-all" onClick={handleClear}>
          Clear All
        </div>
        <div className="action-buttons">
          <button className="btn-secondary" onClick={handleCancel}>
            Cancel
          </button>
          <button className="btn-primary" onClick={handleApply}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
